import useGetTranslations from './useGetTranslations'

export default useGetTranslations
